<template>
  <div class='GoLike'>
    <heartfull-icon :color="Prefes.lojaCorFonte.color"/>
    <div class="text" :style="{ color: Prefes.lojaCorFonte.color }">
      Já se encontra na sua lista de favoritos.
      <label @click="$router.push('/likes')">Ver favoritos</label>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeartfullIcon from '../Icons/HeartfullIcon'
export default {
  name: 'GoLike',
  components: { HeartfullIcon },
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.GoLike {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text {
  padding-left: 2%;
}

label {
  color: #158441;
  cursor: pointer;
}
</style>
